module.exports = __webpack_public_path__ + "static/media/wallrus-info.4dbfaa68.png";